// The DEV environment (nirlat.*.dev.shtibel.com) — built with `npm run build:devenv` and served at
// https://nirlat.biz.dev.shtibel.com (see docs/dev-environment.md)

export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: '',
  },
  tokenKey: 'fd-tokens',
  profileKey: 'user',
  layoutSettingsKey: 'fd-layout',
  languageCookieKey: 'lang',
  permissionKey: 'permissionKey',
  userPermissionsKey: 'userPermissionsKey',
  cookieExpireTime: 30 * 24 * 60 * 60,
  apiUrl: 'https://nirlat.api.dev.shtibel.com/api',
  imageUrl: 'https://nirlat-assets.s3.il-central-1.amazonaws.com/',
  publicUrl: 'https://nirlat.api.dev.shtibel.com/',
  awsenv: 'dev',
};
